import registry from "../../content/registry/company-descriptions.json";

export type CompanyDescription = {
  id: string;
  name: string;
  aliases: string[];
  description: string;
};

export const companyDescriptions = registry.descriptions as CompanyDescription[];

function normalizeCompanyName(value: string): string {
  return value.trim().toLocaleLowerCase();
}

export function findCompanyDescription(value: string): CompanyDescription | undefined {
  const normalized = normalizeCompanyName(value);
  return companyDescriptions.find((company) => company.aliases.some((alias) => normalizeCompanyName(alias) === normalized));
}
